import type { Cv50TaskProgress } from 'app/modules/machine-inventory/interfaces/CleaningTask.types';
import type { RobotCleaningControlService } from 'app/modules/machine-inventory/RobotCleaningControlService';
import { getCurrentCleaningTask } from 'app/modules/machine-inventory/utils/robotCleaningUtils';

/** The device's current task (B50 and CV50). Null when there's no current task. */
export const getCv50TaskProgress = async (
  robotCleaningControlService: RobotCleaningControlService,
  materialNumber: string,
  serialNumber: string
): Promise<Cv50TaskProgress | null> => {
  const task = await getCurrentCleaningTask(robotCleaningControlService, materialNumber, serialNumber);

  if (!task) {
    return null;
  }

  const { id, ...taskFields } = task;

  return { deviceTaskId: id, ...taskFields };
};
